//load modules
import DistributorsPage from './pages/DistributorsPage';
import ProductsPage from './pages/ProductsPage';
import FAQPage from './pages/FAQPage';


//pages
export const pages = [
    DistributorsPage,
    ProductsPage,
    FAQPage
];


// WEBPACK FOOTER //
// ./src/js/pages.js